import React, { useEffect, useState, useRef } from "react";

// Services
import AuthService from "../../../services/auth.service.js";
import CompanyService from "../../../services/companies.service.js";
import assessmentService from "../../../services/assessment.service.js";


// Components
import { Card, CardBody, Col, Row } from "reactstrap";
import { message, Upload, Input } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import WordCountInput from '../../../components/WordCountInput.js'
import  style  from '../style/AssessmentStyle/CaseStudyQuiz.module.css'
import PdfViewer from '../../../components/PdfViewer.js';
import { Download, File } from "react-feather";
import  Link  from "../../../assets/img/icons/Link.png";
import styles from "../style/AssessmentStyle/StartAssessment.module.css";
import {toast} from 'react-toastify';

const { TextArea } = Input;
/*
* Time Based assessment view
*
* This view is responsible for displaying assessment questions & recording the answers
*
* TODO: Combine non time based & time based to a single component
*
* */
const QuizView = (props) => {
    sessionStorage.removeItem("ReSubmitQuestionKey");
    sessionStorage.removeItem("ReviewAssessmentKey");

    var currentUser = AuthService.getCurrentUser();
    let AssessmentID = props.location.state.AssessmentID
    var userId = currentUser.id;
    let CaseStudyDetails = props.location.state.AssessmentsDetails;
    if (currentUser.roleName === "super-admin") {
        props.history.push("/dashboard/default");
        window.location.reload();
    }
    if (currentUser == null || currentUser == undefined) {
        props.history.push("/");
        window.location.reload();
    }

    if (props.location.state == null || props.location.state == undefined) {
        props.history.push({
            pathname: "/Assessments",
        });
        window.location.reload();
    }
    if (props.history.action == "POP") {
        var isKeyPresent = JSON.parse(sessionStorage.getItem("AssessmentQuizKey"));
        if (isKeyPresent == null) {
            props.history.push({
                pathname: "/Assessments",
            });
            window.location.reload();
        }
    }

  
    const fileUrl = './test.pdf';
    const { Dragger } = Upload;
    
    const updateFile = () => {
        var fileData = [];
        assessmentService.GetAssessmentUserDocumentList(props.location.state.CreditId).then((response)=>{
            if(response !== null){
                response.map((item)=>{
                    fileData.push({
                        uid: item._id,
                        name: item._title_text,
                        status: 'done',
                      });
                })
                setFileList(fileData);
            }
        })
    }

    const Props = {
        name: 'file',
        accept:".doc,.docx,application/pdf,.xlsx",
        customRequest(e) {
            const { onSuccess, onError, file } = e;
            var changeFiledata = fileList;
            const fileTypes = [
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Word .docx
                'application/msword', // Word .doc
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel .xlsx
                'application/vnd.ms-excel' // Excel .xls（较旧版本）
            ];
            if(fileTypes.includes(file.type)){
                CompanyService.UploadFilePost(8,props.location.state.CreditId,file,AssessmentID).then((response)=>{
                    if(response.data.Status !== "Success"){
                        onError();
                        toast.error(`${file.name} file upload failed.`,{position: toast.POSITION.TOP_CENTER});
                        updateFile();
                    }else{
                        onSuccess();
                        setFileList(changeFiledata); 
                        toast.success(`${file.name} file uploaded successfully.`,{position: toast.POSITION.TOP_CENTER});
                        updateFile();
                    }
                })
            }else{
                toast.error(`Format error, please upload PDF, Word or Excel file!`,{position: toast.POSITION.TOP_CENTER});
            }  
        },
        onChange(info) {
            const { status } = info.file;
            console.log(info);
            if (status !== 'uploading') {
              console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                console.log(info);
              message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
              message.error(`${info.file.name} file upload failed.`);
            }
        },

        onDrop(e) {
        },
        onRemove(e){
            var deleteFiledata = fileList;
            assessmentService.DeleteAssessmentUserDocument(e.uid).then((response)=>{
                if(response === true){
                    deleteFiledata = deleteFiledata.filter((item)=>{
                        return item.uid !== e.uid;
                    })
                    setFileList(deleteFiledata);
                    toast.success(`${e.name} file removed successfully.`,{position: toast.POSITION.TOP_CENTER});
                }else{
                    toast.error(`${e.name} file removal failed.`,{position: toast.POSITION.TOP_CENTER});
                }
            })
        }
    };
    const [answer,setanswer] = useState([])
    const [pdfData,setpdfData] = useState('')
    const [fileList,setFileList] = useState([])
    useEffect(() => {
        var answerData = [];
        var DocumentData = '';

        for(var i=0;i<props.location.state.AssessmentsDetails.QuestionList.length;i++){
            answerData[i] = {
                UserId: userId,
                QiQuestionId: props.location.state.AssessmentsDetails.QuestionList[i].QuestionId,
                Answer: props.location.state.AssessmentsDetails.QuestionList[i].Answer,
                CreditId: props.location.state.CreditId,
                AssessmentId:props.location.state.AssessmentID,
                isSave:false
            }
        }
        for(var i=0;i<props.location.state.AssessmentsDetails.AssessmentDocumentList.length;i++){
           if(props.location.state.AssessmentsDetails.AssessmentDocumentList[i].ViewDocument === true){
                DocumentData = 'data:application/pdf;base64,' + props.location.state.AssessmentsDetails.AssessmentDocumentList[i].DocumentString;
                CaseStudyDetails.AssessmentDocumentList.splice(i,1) ;
                break;
           }
        }
        updateFile()
        setanswer(answerData); 
        setpdfData(DocumentData);
    }, []);

 

    // TODO: remove the following & use moment.js to handle time
    const formatToHoursAndMinutes = (secondsVal) => {
        if (secondsVal < 0) {
            secondsVal = Math.abs(secondsVal);
            var sec_num = parseInt(secondsVal, 10);
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor(sec_num / 60) % 60;
            var seconds = sec_num % 60;

            return [hours, minutes, seconds]
                .map((v,i) => (v < 10 ? "0" + v : v))
                .filter((v, i) =>  v !== "00" || i > 0)
                .join(":");

        }else{
            var sec_num = parseInt(secondsVal, 10);
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor(sec_num / 60) % 60;
            var seconds = sec_num % 60;

            return [hours, minutes, seconds]
                .map((v) => (v < 10 ? "0" + v : v))
                .filter((v, i) => v !== "00" || i > 0)
                .join(":");
        }
        
    };

    const CaseStudyonChange = (item,e) => {
        var value = answer;
        for (let i = 0; i < value.length; i++) {
            if (value[i].QiQuestionId == item.QuestionId) {
              value[i].Answer = e;
              break;
            }
        }
        setanswer(value);
    };
    const CaseStudySubmit = (isSave ) => {
        const IsConform = answer.every(item => item.Answer !== '');
        var answerDatas = answer;
        if(isSave){ 
            for(var i=0;i<answer.length;i++){
                answerDatas[i].isSave = true;
            }
            assessmentService.AddCaseStudyList(answerDatas).then((response)=>{
                if(response.Status === "Success"){
                    assessmentService.GetAllAssessmentListByCreditId(userId, props.location.state.AssessmentID, props.location.state.CreditId).then((response1) =>{
                        if(response1 !== null) {
                            toast.success('Save success!', {position: toast.POSITION.TOP_CENTER})
                        }
                        
                    })
                }
             }).catch((error)=>{
                 console.log(error);
             });
        }else{
            if(IsConform){
                for(var i=0;i<answer.length;i++){
                    answerDatas[i].isSave = false;
                }
                assessmentService.AddCaseStudyList(answerDatas).then((response)=>{
                    if(response.Status === "Success"){
                        assessmentService.GetAllAssessmentListByCreditId(userId, props.location.state.AssessmentID, props.location.state.CreditId).then((response1) =>{
                            if(response1 !== null) {
                                    props.history.push({
                                    pathname: '/Assessments/Completed',
                                    state: { GoOnInfo: false, LinkedAssessmentId: props.location.state.AssessmentID, LinkedAssessmentCreditId: props.location.state.CreditId,AssessmentName:response1.AssessmentName,AssessmentsDetails:response1[0] }
                                })
                            }
                            
                        })
                    }
                 }).catch((error)=>{
                     console.log(error);
                 });
            }else{
                toast.error('Please fill all the questions', {position: toast.POSITION.TOP_CENTER})
            }
        }
      
    }
    const DownloadPdf = (url) => {
        const a = document.createElement('a');
        a.href = url;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    return (
        <>
            <Row>
                <div className="col-lg-8 col-md-9">
                    <Card
                        className="my-card"
                        id="assessment-wrapper-list"
                        style={{padding:'2rem'}}
                    >
                        <div className={style.PDF}>
                            <PdfViewer data={pdfData} />
                        </div>
                        <div className={style.questions}>
                        {CaseStudyDetails.QuestionList.map((item,index)=>{
                            return(
                                <Row key={index} className={styles.introduce_item}>
                                    <div className="col-lg-1 col-md-1" style={{display: 'flex',justifyContent: 'center'}}>
                                        <div className="question-number rounded-circle text-white font-weight-bold h3" style={{flexShrink: '0'}}>
                                        {index+1}
                                        </div>
                                    </div>
                                    <div className="col-lg-11 col-md-11 ml-0" >
                                        <div dangerouslySetInnerHTML={{__html:item.Question}}>

                                        </div>
                                        <div className={style.answer}>
                                        <WordCountInput 
                                            maxWords={500}
                                            value={CaseStudyDetails.QuestionList[index].Answer}
                                            onChange={(e)=>{
                                                CaseStudyonChange(item,e)}}
                                        />
                                        </div>
                                    </div>
                                </Row>
                            )
                        })}
                        </div>
                    </Card>
 
                </div>
                <div className={`col-lg-4 col-md-3 ${style.sidebar}`}>
                    <Card
                        className="my-card"
                        id="assessment-wrapper-list"
                        style={{padding:'2rem 0'}}
                    >   
                    <CardBody className="py-0 scrollbar1"  style={{overflowY: "scroll",marginBottom:'2rem'}}>
                        <span style={{fontSize:'30px',fontWeight:'bold',color:'#000000'}}>
                            Instructions
                        </span>
                        <hr/>
                        {props.location.state.AssessmentsInfo.AssessmentDescriptionDetailList.map((item,index)=>{
                            if(item.TypeId == '7'){
                                return(
                                    <div key={index} dangerouslySetInnerHTML={{__html:item.AhriDescription}}>
                                    </div>
                                )
                             }
                        })
                        }
                        
                    </CardBody>
                    <CardBody className="py-0 scrollbar1"  style={{overflowY: "scroll",marginBottom:'2rem'}}>
                        <span style={{fontSize:'30px',fontWeight:'bold',color:'#000000'}}>
                            Additional
                            Documents
                        </span>
                        <hr/>
                        <div className="my-sidenav">
                            {CaseStudyDetails.AssessmentDocumentList.map((item,index)=>{
                                return(
                                    <div className="d-flex" key={index} style={{marginBottom: '1rem'}}>
                                        <div className="LinkIcon">
                                            <img src={Link} alt="linkicon" style={{height:'2rem',marginRight:'1rem'}} />
                                        </div>
                                        <div className={style.LinkName} style={{lineHeight: 'normal'}} onClick={()=>{
                                            DownloadPdf(item.DocumentUrl)
                                        }}>
                                            {item.TitleText}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </CardBody>
                    {props.location.state.AssessmentsInfo.AiAssessmentType == '3' && <CardBody className="py-0 scrollbar1"  style={{overflowY: "scroll"}}>
                        <Row>
                            <Col md={12} sm={12}>
                                <div className="my-sidenav">
                                <span style={{fontSize:'30px',fontWeight:'bold',color:'#000000'}}>
                                    Supporting Documents
                                </span>
                                <hr/>
                                    <Dragger {...Props} fileList={fileList}>
                                        <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                        <p className="ant-upload-hint">
                                        Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                                        banned files.<br/>Supported formats: .pdf, .docx, .xls, .xlxs
                                        </p>
                                    </Dragger>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>}
                    <div style={{padding:'0 20px'}}>
                            <button
                                id="submit-button"
                                className="quiz-submit-btn btn btn-primary mr-1"
                                style={{marginBottom:'1rem',marginTop:'2rem',width:'100%',backgroundColor:'var(--theme_color1)'}}
                                onClick={()=>{
                                    CaseStudySubmit(true)}}
                            >
                                Save
                            </button>
                            <button
                                id="submit-button"
                                className="quiz-submit-btn btn btn-primary mr-1"
                                style={{marginBottom:'1rem',width:'100%'}}
                                onClick={()=>{
                                    CaseStudySubmit(false)}}
                            >
                                Submit Assessment
                            </button>
                    </div>
                    </Card>
                </div>
            </Row>
        </>
    );
};

const CaseStudyQuiz = (props) => (
    <>
        <QuizView {...props} />
    </>
);

export default CaseStudyQuiz;
